import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import ModalSucursales from './ModalSucursales';
import { useAccesos } from '../contexts/AccesosContext';
import { useSucursal } from '../contexts/SucursalContext';
import { fetchWithToken, isTokenValid, clearToken } from '../utils/apiInterceptor';
function Login({ setIsAuthenticated }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;

    // Add console log to debug
    // console.log('API Route:', process.env.REACT_APP_API_ROUTE);

    const [usuario, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [sucursales, setSucursales] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');
    const navigate = useNavigate();
    const { login } = useUser();
    const { setSucursalSeleccionada } = useSucursal();

    const { setAccesos, setPermisos } = useAccesos(); 



    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        setError('');
        
        try {
            // Limpiar token anterior si existe pero no es válido
            if (!isTokenValid()) {
                clearToken();
            }

            // Configurar los datos a enviar en el cuerpo de la solicitud
            const bodyData = {
                usuario: usuario,
                password: password
            };

            const response = await fetchWithToken(`${server}/sg_sucursal_usuario_perfil/autenticacionsucursalesbyusuario`, {
                method: 'POST',
                body: JSON.stringify(bodyData)
            });

            if (response.ok) {
                const data = await response.json();
                // La respuesta ahora tiene una estructura diferente con 'result'
                if (data && data.result && data.result.sucursales) {
                    const { $values: sucursalesList } = data.result.sucursales;
                    setSucursales(sucursalesList);
                    setShowModal(true);
                    setIsAuthenticated(true);

                    // Store the new token in local storage
                    localStorage.setItem('token', data.result.token);
                    localStorage.setItem("username", usuario); // ✅ NUEVO: clave para rehidratar en F5
                    await login(usuario);
                } else if (data && data.sucursales) {
                    // Mantener compatibilidad con la respuesta anterior
                    const { $values: sucursalesList } = data.sucursales;
                    setSucursales(sucursalesList);
                    setShowModal(true);
                    setIsAuthenticated(true);

                    // Store the token in local storage
                    localStorage.setItem('token', data.token);
                    localStorage.setItem("username", usuario); // ✅ NUEVO: clave para rehidratar en F5
                    await login(usuario);
                } else {
                    setError('Usuario o contraseña incorrectos o no tiene sucursales asignadas');
                    setIsAuthenticated(false);
                }
            } else {
                if (response.status === 401) {
                    setError('Usuario o contraseña incorrectos');
                } else if (response.status === 403) {
                    setError('Acceso denegado. Verifique sus credenciales.');
                } else if (response.status >= 500) {
                    setError('Error del servidor. El servicio no está disponible en este momento.');
                } else if (response.status === 404) {
                    setError('Servicio no encontrado. Contacte al administrador.');
                } else {
                    setError('Error en la autenticación. Verifique sus credenciales.');
                }
            }
        } catch (error) {
            // Solo mostrar error si realmente no se puede conectar o hay un error de red
            if (error.message.includes('fetch') || error.message.includes('Failed to fetch')) {
                setError('No se pudo conectar al servidor. Verifique que el servicio esté activo.');
            } else if (error.message.includes('NetworkError') || error.message.includes('ERR_NETWORK')) {
                setError('Error de red. Verifique su conexión a internet.');
            } else if (error.message.includes('ERR_CONNECTION_REFUSED')) {
                setError('El servidor no está disponible. Contacte al administrador.');
            } else {
                setError('Error inesperado al conectar con el servidor.');
            }
            console.error('Error al autenticar el usuario:', error);
        } finally {
            setIsLoading(false);
        }
    };


    const handleSucursalSelection = async (u, p, sucursal) => {
        setShowModal(false);
        setIsLoading(true);
        setError('');

        // Actualiza el contexto con la sucursal seleccionada
        setSucursalSeleccionada(sucursal);
        localStorage.setItem("sucursalSeleccionada", JSON.stringify(sucursal)); // ✅
        try {
            const bodyData = {
                usuario: usuario,
                password: password,
                idSucursal: sucursal.idSucursal
            };

            const response = await fetchWithToken(`${server}/sg_sucursal_usuario_perfil/autenticacionamenubysucursal`, {
                method: 'POST',
                body: JSON.stringify(bodyData)
            });

            const response1 = await fetchWithToken(`${server}/sg_sucursal_usuario_perfil/autenticacionapermisosbysucursal`, {
                method: 'POST',
                body: JSON.stringify(bodyData)
            });

            if (response.ok) {
                const data = await response.json();
              const cleanAccesos = (data?.$values || []).filter(Boolean);
                setAccesos(cleanAccesos);
                //localStorage.setItem("accesos", JSON.stringify(cleanAccesos)); // ✅ ahora ya no guardas null
                if (response1.ok) {
                    const data1 = await response1.json();
                   const cleanPermisos = (data1?.$values || []).filter(Boolean);

                    setPermisos(cleanPermisos);
                    //localStorage.setItem("permisos", JSON.stringify(cleanPermisos));
                }
                navigate('/');
            } else {
                if (response.status === 401) {
                    setError('Sesión expirada. Por favor, inicie sesión nuevamente.');
                    navigate('/login');
                } else if (response.status === 403) {
                    setError('No tiene permisos para acceder a esta sucursal.');
                } else if (response.status >= 500) {
                    setError('Error del servidor. El servicio de accesos no está disponible.');
                } else {
                    setError('Error al obtener accesos del sistema');
                }
            }
        } catch (error) {
            // Manejar errores específicos de token
            if (error.message.includes('Token expirado') || error.message.includes('Token inválido')) {
                setError('Sesión expirada. Por favor, inicie sesión nuevamente.');
                clearToken();
                navigate('/login');
                return;
            }
            
            // Solo mostrar error si realmente no se puede conectar
            if (error.message.includes('fetch') || error.message.includes('Failed to fetch')) {
                setError('No se pudo conectar al servidor de accesos. Verifique que el servicio esté activo.');
            } else if (error.message.includes('NetworkError') || error.message.includes('ERR_NETWORK')) {
                setError('Error de red al cargar los accesos del sistema.');
            } else {
                setError('Error inesperado al cargar los accesos del sistema');
            }
            console.error('Error al cargar los accesos:', error);
        } finally {
            setIsLoading(false);
        }
    };



    return (
        <>
            <div className="login_wrapper">
                <div className="animate form login_form">
                    <section className="login_content">
                        <form onSubmit={handleSubmit}>
                            <h1>Formulario Inicio</h1>
                            
                            {error && (
                                <div className="alert alert-danger" role="alert">
                                    {error}
                                </div>
                            )}
                            
                            <div>
                                <input
                                    type="text"
                                    value={usuario}
                                    className='form-control'
                                    placeholder='Usuario'
                                    onChange={(e) => setUsername(e.target.value)}
                                    disabled={isLoading}
                                    required
                                />
                            </div>
                            <div>
                                <input
                                    type="password"
                                    value={password}
                                    className='form-control'
                                    placeholder='Contraseña'
                                    onChange={(e) => setPassword(e.target.value)}
                                    disabled={isLoading}
                                    required
                                />
                            </div>
                            <div>
                                <button 
                                    className='btn btn-default' 
                                    type="submit"
                                    disabled={isLoading}
                                    style={{ position: 'relative' }}
                                >
                                    {isLoading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ marginRight: '8px' }}></span>
                                            Iniciando sesión...
                                        </>
                                    ) : (
                                        'Ingresar'
                                    )}
                                </button>
                            </div>
                        </form>
                    </section>
                </div>

                {/* Overlay de carga completa */}
                {isLoading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            padding: '30px',
                            borderRadius: '10px',
                            textAlign: 'center',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
                        }}>
                            <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
                                <span className="sr-only">Cargando...</span>
                            </div>
                            <p style={{ marginTop: '15px', marginBottom: 0 }}>
                                {showModal ? 'Cargando accesos del sistema...' : 'Autenticando usuario...'}
                                <br />
                                <small style={{ color: '#666', fontSize: '12px' }}>
                                    Por favor espere, esto puede tomar unos momentos
                                </small>
                            </p>
                        </div>
                    </div>
                )}
            </div>
            
            {showModal && !isLoading && (
                <ModalSucursales
                    title="Seleccione una Sucursal"
                    onClose={() => setShowModal(false)}
                    onConfirm={handleSucursalSelection}
                    items={sucursales}
                />
            )}
        </>
    );
}

export default Login;
